import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import LanguageDetector from 'i18next-browser-languagedetector';
// If you want to serve JSON files from your app bundle:
import authEn from "./locales/en/auth.json";
import sidebarEn from "./locales/en/sideBar.json";
import overviewEn from "./locales/en/overview.json";
import servicesEn from "./locales/en/services.json";
import globalEn from "./locales/en/global.json";
import staffEn from "./locales/en/staff.json";
import calendarEn from "./locales/en/calendar.json";
import rosterEn from "./locales/en/roster.json";
import searchEn from "./locales/en/search.json";
import paymentsEn from "./locales/en/payments.json";
import CancelAppointmentEn from './locales/en/cancelAppointment.json';
import bookingThemeEn from "./locales/en/bookingTheme.json";
import onlineBookingEn from "./locales/en/onlineBooking.json";
import bookingDetailsEn from "./locales/en/bookingDetails.json";
import bookingB2CEn from "./locales/en/bookingB2C.json";
import makeBookingEn from "./locales/en/makingBooking.json";
import clientSiteEn from "./locales/en/clientSite.json";
import miniSiteGeneralEn from "./locales/en/miniSiteGeneral.json";
import miniSiteEn from "./locales/en/miniSite.json";
import miniSiteThemeEn from "./locales/en/miniSiteTheme.json";
import miniSiteBusinessInfoEn from "./locales/en/miniSiteBusinessInfo.json";
import miniSiteSectionsEn from "./locales/en/miniSiteSections.json";
import miniSiteSocialsEn from "./locales/en/miniSiteSocials.json";
import supportEn from "./locales/en/support.json";
import settingsEn from "./locales/en/settings.json";
import policyEn from "./locales/en/policy.json"

import authEs from "./locales/es/auth.json";
import makeBookingEs from "./locales/es/makingBooking.json";



i18n
  .use(ICU)               // plural rules, formatting
  .use(initReactI18next)
  .init({
    resources: {
      en: {  auth: authEn, sidebar: sidebarEn, overview: overviewEn, services: servicesEn, global: globalEn, staff: staffEn, calendar: calendarEn, roster: rosterEn, search: searchEn, payments: paymentsEn, cancelAppointment: CancelAppointmentEn, bookingTheme: bookingThemeEn, onlineBooking: onlineBookingEn, bookingDetails: bookingDetailsEn, bookingB2C: bookingB2CEn, makeBooking: makeBookingEn, clientSite: clientSiteEn, miniSiteGeneral: miniSiteGeneralEn, miniSite: miniSiteEn, miniSiteTheme: miniSiteThemeEn, miniSiteBusinessInfo: miniSiteBusinessInfoEn, miniSiteSections: miniSiteSectionsEn, miniSiteSocials: miniSiteSocialsEn, support: supportEn, settings: settingsEn, policy: policyEn},
      es: { auth: authEs, makeBooking: makeBookingEs}
    },
    lng: 'en-GB',                  // default; we’ll override from backend
    fallbackLng: 'en-GB',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ui.lang'
    }

  });

export default i18n;